import React from 'react';
import { DayCarouselCardProps, SelectedDayFilter } from '@msc-b2c/interfaces/types';
import styles from './explorebydaycarousel.module.scss';
import dayjs from 'dayjs';
import { Chip, Image } from '@msc-b2c/shared-components';
import {
  AppDispatch,
  daySelected,
  getLocale,
  handleKeyDown,
  resolveDateFormat,
} from '@msc-b2c/shared-utils';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { triggerClickCtaEvent } from '../utils/myAreaAnalytics';
import { getContainerInfo } from '../utils/analyticsUtils';

const DayCarouselCard: React.FC<DayCarouselCardProps> = ({
  dayData,
  dayIndex,
  dayPlaceHolder,
  dayCardDateFormat,
  departureInfo,
  backgroundImage,
  placeholderImagePath,
  navigationLink,
  showOceanKayPill,
  oceanKayPillLabel,
  oceanKayPillBgColor,
  oceanKayPillTextColor,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const portName = dayData.port.name;
  const date = dayData.date;
  const formatedDate = dayjs(date).locale(getLocale()).format(resolveDateFormat(dayCardDateFormat));
  const formattedDayPlaceholder = dayPlaceHolder
    .replace('{dayIndex}', dayIndex.toString())
    .replace('{date}', formatedDate);
  const accessibleLabel = departureInfo
    ? `${formattedDayPlaceholder}, ${portName}, ${departureInfo}`
    : `${formattedDayPlaceholder}, ${portName}`;

  const onClick = () => {
    const container = document.querySelector('.explorebydaycarousel');

    triggerClickCtaEvent({
      cta_dest_link: navigationLink,
      click_main_name: `Explore by Day - ${portName}`,
      container_info: getContainerInfo(container),
      element_position: `Day ${dayIndex} - ${portName}`,
      element_type: 'carousel',
      click_location: `${dayIndex}`,
    });

    const selectedDay: SelectedDayFilter = {
      portCode: dayData.port.code,
      date: dayData.date,
    };
    dispatch(daySelected(selectedDay));
    navigate(`/excursions${window.location.href.includes('.html') ? '.html' : ''}`);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={accessibleLabel}
      className={styles.cardLink}
      onClick={onClick}
      onKeyDown={(event) => handleKeyDown(event, onClick)}
    >
      <div className={styles.dayCarouselCardContainer}>
        <Image
          src={backgroundImage}
          alt={portName}
          styleOption={styles.cardImage}
          placeholderImagePath={placeholderImagePath}
        />
        <div className={styles.cardTopContent}>
          {showOceanKayPill && (
            <Chip
              text={oceanKayPillLabel}
              styleOption={styles.oceanKayPill}
              ribbonBGColor={oceanKayPillBgColor}
              ribbonTextColor={oceanKayPillTextColor}
              isBadge
            />
          )}
        </div>

        <div className={styles.cardBottomContent}>
          <p className={styles.dayPlaceholder}>{formattedDayPlaceholder}</p>
          <p className={styles.portName}>{portName}</p>
          {departureInfo && <p className={styles.departureInfo}>{departureInfo}</p>}
        </div>
      </div>
    </div>
  );
};

export default DayCarouselCard;
